import {
  Box,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  styled,
  Typography,
  Checkbox,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../../components/common/CustomButton";
import TextFieldBox from "../../components/common/TextField";
import { apiPost } from "../../utils/Api/ApiCalls";
import { API_ROUTES } from "../../utils/Api/ApiConfig";
import { colors } from "../../utils/colors/Index";

function CreateCalls({ setRender }) {
  const [formData, setFormData] = useState({
    notes: "",
    entryPrice: "",
    targetPrice1: "",
    targetPrice2: "",
    stopLoss: "",
    profitPotential: "",
  });
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("buy");
  const [selectedMsgType, setSelectedMsgType] = useState({
    all: false,
    subscriber: false,
  });

  const handleChangeCheckbox = (event) => {
    setSelectedMsgType({
      ...selectedMsgType,
      [event.target.name]: event.target.checked,
    });
  };
  const handleChangeRadio = (event) => {
    console.log(event.target.value);

    setSelectedOption(event.target.value);
  };
  // const calculateProfitPotential = (entryPrice, targetPrice) => {
  //   if (
  //     entryPrice &&
  //     targetPrice &&
  //     !isNaN(entryPrice) &&
  //     !isNaN(targetPrice)
  //   ) {
  //     const profit = ((targetPrice - entryPrice) / entryPrice) * 100;
  //     return parseFloat(profit.toFixed(2));
  //   }
  //   return "";
  // };
  const calculateProfitPotential = (entryPrice, targetPrice) => {
    if (
      entryPrice &&
      targetPrice &&
      !isNaN(entryPrice) &&
      !isNaN(targetPrice)
    ) {
      const profit = ((targetPrice - entryPrice) / entryPrice) * 100;
      return parseFloat(Math.abs(profit).toFixed(2));
    }
    return "";
  };

  const handleChange = (field) => (event) => {
    const value = event.target.value;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [field]: field === "notes" ? value : parseFloat(value) || 0, // Parse value as a number
      };

      if (field === "entryPrice" || field === "targetPrice1") {
        updatedData.profitPotential = calculateProfitPotential(
          parseFloat(updatedData.entryPrice) || 0,
          parseFloat(updatedData.targetPrice1) || 0
        );
      }

      return updatedData;
    });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.notes.trim()) newErrors.notes = "Notes are required.";
    if (!formData.entryPrice || isNaN(formData.entryPrice))
      newErrors.entryPrice = "Entry Price must be a valid number.";
    if (!formData.targetPrice1 || isNaN(formData.targetPrice1))
      newErrors.targetPrice1 = "Target Price 1 must be a valid number.";
    if (!formData.targetPrice2 || isNaN(formData.targetPrice2))
      newErrors.targetPrice2 = "Target Price 2 must be a valid number.";
    if (!formData.stopLoss || isNaN(formData.stopLoss))
      newErrors.stopLoss = "Stop Loss must be a valid number.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const fetchCallData = async () => {
    setLoader(true);
    const body = {
      callName: formData?.notes,
      target: [
        { targetName: "Entry Price", price: formData?.entryPrice },
        { targetName: "Stop Loss", price: formData?.stopLoss },
        { targetName: "Target Price 1", price: formData?.targetPrice1 },
        { targetName: "Target Price 2", price: formData?.targetPrice2 },
      ],
      profitPotential: formData?.profitPotential,
      status: "Open",
      actionType: selectedOption,
    };
    try {
      const response = await apiPost(API_ROUTES.POST_CALLS, body);
      if (response?.status === 201) {
        setLoader(false);
        setFormData({
          notes: "",
          entryPrice: "",
          targetPrice1: "",
          targetPrice2: "",
          stopLoss: "",
          profitPotential: "",
        });
        setRender((prevRender) => !prevRender);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Error creating call. Please try again.");
      setLoader(false);
    }
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      await fetchCallData();
      console.log("Form submitted successfully:", formData);
    }
  };

  return (
    <Container>
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        Create Call
      </Typography>
      <Divider sx={{ color: "border.primary" }} />

      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "1rem" }}>
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          {/* <Box sx={{ backgroundColor: "#FFF9E6", padding: "8px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  name="all"
                  checked={selectedMsgType.all}
                  onChange={handleChangeCheckbox}
                  sx={{
                    "&.Mui-checked": {
                      color: "green",
                    },
                  }}
                />
              }
              label="Free Trail"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="subscriber"
                  checked={selectedMsgType.subscriber}
                  onChange={handleChangeCheckbox}
                  sx={{
                    "&.Mui-checked": {
                      color: "green",
                    },
                  }}
                />
              }
              label="Subscribed User"
            />
          </Box> */}
          <Box sx={{ backgroundColor: "#FFF9E6", padding: "8px" }}>
            <RadioGroup
              row
              name="buy-sell"
              defaultValue="buy"
              value={selectedOption}
              onChange={handleChangeRadio}
            >
              <FormControlLabel
                value="buy"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "green",
                      },
                    }}
                  />
                }
                label="Buy"
              />
              <FormControlLabel
                value="sell"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "Red",
                      },
                    }}
                  />
                }
                label="Sell"
              />
            </RadioGroup>
          </Box>
          <Typography variant="h6">Notes</Typography>
          <TextFieldBox
            value={formData.notes}
            onChange={handleChange("notes")}
            multiline
            placeholder="Enter Notes"
            rows={2}
            error={!!errors.notes}
            helperText={errors.notes}
          />
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          <Typography>Entry Price</Typography>
          <TextFieldContainer>
            <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
              <RupeeContainer>
                <Typography>₹</Typography>
              </RupeeContainer>
              <TextFieldBox
                type="number"
                value={formData.entryPrice}
                onChange={handleChange("entryPrice")}
                placeholder="Enter Entry Price"
              />
            </Box>
            {errors.entryPrice && (
              <Typography
                variant="caption"
                color="error"
                sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
              >
                {errors.entryPrice}
              </Typography>
            )}
          </TextFieldContainer>
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          <Typography>Target Price 1</Typography>
          <TextFieldContainer>
            <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
              <RupeeContainer>
                <Typography>₹</Typography>
              </RupeeContainer>
              <TextFieldBox
                type="number"
                value={formData.targetPrice1}
                onChange={handleChange("targetPrice1")}
                placeholder="Enter Target Price 1"
              />
            </Box>
            {errors.targetPrice1 && (
              <Typography
                variant="caption"
                color="error"
                sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
              >
                {errors.targetPrice1}
              </Typography>
            )}
          </TextFieldContainer>
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          <Typography>Target Price 2</Typography>
          <TextFieldContainer>
            <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
              <RupeeContainer>
                <Typography>₹</Typography>
              </RupeeContainer>
              <TextFieldBox
                type="number"
                value={formData.targetPrice2}
                onChange={handleChange("targetPrice2")}
                placeholder="Enter Target Price 2"
              />
            </Box>
            {errors.targetPrice2 && (
              <Typography
                variant="caption"
                color="error"
                sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
              >
                {errors.targetPrice2}
              </Typography>
            )}
          </TextFieldContainer>
        </Box>{" "}
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          <Typography>Stop Loss</Typography>
          <TextFieldContainer>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <RupeeContainer>
                <Typography>₹</Typography>
              </RupeeContainer>
              <TextFieldBox
                type="number"
                value={formData.stopLoss}
                onChange={handleChange("stopLoss")}
                placeholder="Enter Stop Loss"
              />
            </Box>
            {errors.stopLoss && (
              <Typography
                variant="caption"
                color="error"
                sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
              >
                {errors.stopLoss}
              </Typography>
            )}
          </TextFieldContainer>
        </Box>{" "}
        <Box
          sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
        >
          <Typography>Profit Potential</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <RupeeContainer>
              <Typography>%</Typography>
            </RupeeContainer>
            <TextFieldBox
              type="number"
              value={formData.profitPotential}
              onChange={handleChange("profitPotential")}
              placeholder="Enter Profit Potential"
              error={!!errors.profitPotential}
              helperText={errors.profitPotential}
              disabled
            />
          </Box>
        </Box>
      </Box>

      <CustomButton
        title="Send"
        onClick={handleSubmit}
        loading={loader}
        sx={{
          backgroundColor: "#FFC200",
          color: "white",
          textTransform: "capitalize",
        }}
      />
    </Container>
  );
}

export default CreateCalls;
const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "1rem",
  rowGap: "1rem",
  borderRadius: 16,
  boxShadow: "0px 1px 2px 1px #DCDCDC",
  backgroundColor: theme.palette.background.paper,
  height: "100%",
  overflowY: "auto",
}));
const RupeeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0.5rem 1rem",
  backgroundColor: "#FFF9E6",
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
}));
const TextFieldContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
}));
